<div class="seg">
  <!-- ------------------------------------------------------------ cabecera -->
  <div class="seg-header">
    <div>
      <h1>Seguimiento de clientes</h1>
      <p class="seg-sub">
        Retención de la mesa USDT. El dato sale de la base en vivo: no hay planillas.
      </p>
    </div>

    <div class="seg-header-acciones">
      <span class="seg-chip" [class.on]="conectado" [title]="conectado ? 'Recibiendo cambios en vivo' : 'Sin canal en vivo: los números son de la última foto'">
        <span class="punto"></span>{{ conectado ? 'En vivo' : 'Sin canal' }}
      </span>

      <span class="seg-datos-al" *ngIf="datosAl">
        Datos al {{ datosAl | date: 'dd/MM HH:mm' }}
      </span>

      <button mat-stroked-button (click)="refrescar()" [disabled]="refrescando">
        <mat-icon>{{ refrescando ? 'hourglass_empty' : 'refresh' }}</mat-icon>
        {{ refrescando ? 'Actualizando…' : 'Actualizar' }}
      </button>

      <button mat-stroked-button (click)="abrirConfig()" [disabled]="!config">
        <mat-icon>tune</mat-icon> Configuración
      </button>
    </div>
  </div>

  <div class="seg-error" *ngIf="error">{{ error }}</div>
  <div class="seg-cargando" *ngIf="cargando">Cargando el tablero…</div>

  <!-- El universo vacío no es un tablero en cero: es un tablero sin arrancar,
       y tiene que decirlo en vez de dejar seis tarjetas en cero. -->
  <div class="seg-arranque" *ngIf="universoVacio">
    <h2>El seguimiento todavía no arrancó</h2>
    <p>
      No hay ningún cliente en el universo, así que el tablero está correcto y
      vacío. Hay que armarlo una vez: se toman los titulares que vendieron USDT
      desde <b>{{ config?.historiaDesde || 'enero' }}</b>, se unen sus cuentas por
      documento, y se calcula cuánto valía cada uno cuando estaba entero.
    </p>
    <p class="chico">
      Son tres pasos y se pueden repetir cuando aparezcan cuentas nuevas. No
      borran nada.
    </p>
    <button mat-flat-button color="primary" (click)="arrancar()" [disabled]="sembrando">
      <mat-icon>play_arrow</mat-icon>
      {{ sembrando ? 'Trabajando…' : 'Arrancar el seguimiento' }}
    </button>
    <p class="paso" *ngIf="pasoSiembra">{{ pasoSiembra }}</p>
  </div>

  <!-- Uniones propuestas por nombre: el contador de la fila no sirve si no hay
       forma de resolverlas. -->
  <div class="seg-uniones" *ngIf="propuestas.length && !universoVacio">
    <div>
      <b>{{ propuestas.length }}</b> unión(es) de cuenta esperando confirmación.
      Se propusieron por nombre, no por documento: unir dos homónimos mezcla el
      volumen de dos clientes distintos.
    </div>
    <button mat-stroked-button (click)="resolverPropuestas()">Revisar</button>
  </div>

  <ng-container *ngIf="!cargando && semana">
    <!-- ----------------------------------------------------------- resumen -->
    <div class="seg-kpis">
      <div class="kpi">
        <div class="kpi-l">Semana</div>
        <div class="kpi-b">{{ semana.fechaInicio | date: 'dd/MM' }} – {{ semana.fechaFin | date: 'dd/MM' }}</div>
        <div class="kpi-s">
          {{ semana.dias }} {{ semana.dias === 1 ? 'día' : 'días' }} ·
          {{ semana.estado === 'ABIERTA' ? 'en curso' : 'cerrada' }}
        </div>
      </div>

      <div class="kpi">
        <div class="kpi-l">USDT de la semana</div>
        <div class="kpi-b num">{{ semana.usdtTotal | number: '1.0-0' }}</div>
        <div class="kpi-s">
          de {{ semana.usdtEsperado | number: '1.0-0' }} esperados
          <b *ngIf="cumplimiento !== null">· {{ cumplimiento }}%</b>
        </div>
      </div>

      <div class="kpi">
        <div class="kpi-l">En rojo</div>
        <div class="kpi-b num rojo">{{ contar('ROJO') }}</div>
        <div class="kpi-s">{{ semana.whalesRojo }} son whales</div>
      </div>

      <div class="kpi">
        <div class="kpi-l">En amarillo</div>
        <div class="kpi-b num ambar">{{ contar('AMARILLO') }}</div>
        <div class="kpi-s">vigilar</div>
      </div>

      <div class="kpi">
        <div class="kpi-l">Whales sanos</div>
        <div class="kpi-b num verde">{{ whalesVerdes }}</div>
        <div class="kpi-s">de {{ whalesTotal }} whales</div>
      </div>

      <div class="kpi">
        <div class="kpi-l">Perdidos</div>
        <div class="kpi-b num">{{ semana.clientesFugado }}</div>
        <div class="kpi-s">
          <span *ngIf="semana.usdtFugadoReferencia">
            {{ semana.usdtFugadoReferencia | number: '1.0-0' }} USDT/mes en juego
          </span>
          <span *ngIf="!semana.usdtFugadoReferencia">a reconquistar</span>
        </div>
      </div>
    </div>

    <mat-tab-group (selectedIndexChange)="alCambiarPestana($event)" animationDuration="0ms">
      <!-- ================================================== 1. TABLERO -->
      <mat-tab label="Tablero">
        <div class="seg-tab">
          <div class="seg-filtros">
            <div class="grupo">
              <button
                *ngFor="let f of ['WHALE', 'ALERTA', 'TODOS']"
                [class.on]="filtroTier === f"
                (click)="filtroTier = $any(f)"
              >
                {{ f === 'WHALE' ? 'Whales' : f === 'ALERTA' ? 'Sólo alertas' : 'Todos' }}
              </button>
            </div>

            <div class="grupo">
              <button [class.on]="filtroColor === 'TODOS'" (click)="filtroColor = 'TODOS'">
                Todo color
              </button>
              <button class="c-rojo" [class.on]="filtroColor === 'ROJO'" (click)="filtroColor = 'ROJO'">
                Rojo {{ contar('ROJO') }}
              </button>
              <button class="c-ambar" [class.on]="filtroColor === 'AMARILLO'" (click)="filtroColor = 'AMARILLO'">
                Amarillo {{ contar('AMARILLO') }}
              </button>
              <button class="c-verde" [class.on]="filtroColor === 'VERDE'" (click)="filtroColor = 'VERDE'">
                Verde {{ contar('VERDE') }}
              </button>
              <button [class.on]="filtroColor === 'FUGADO'" (click)="filtroColor = 'FUGADO'">
                Perdidos {{ contar('FUGADO') }}
              </button>
            </div>

            <label class="seg-check">
              <input type="checkbox" [(ngModel)]="soloConDueno" /> Con dueño
            </label>

            <label class="seg-check" *ngIf="miSub">
              <input type="checkbox" [(ngModel)]="soloMias" /> Mi cartera
            </label>

            <label
              class="seg-check"
              title="Whales todas las semanas; medios cada {{ config?.cadenciaMedioSemanas || 2 }} semanas"
            >
              <input type="checkbox" [(ngModel)]="soloDeEstaSemana" /> Toca esta semana
            </label>

            <label
              class="seg-check"
              *ngIf="config?.silencioFactor"
              title="Lleva más de {{ config?.silencioFactor }} veces su propia cadencia sin aparecer. Es otra cola de trabajo: el 31% de estos no está en rojo."
            >
              <input type="checkbox" [(ngModel)]="soloSilencio" />
              Callados ({{ contarSilencio() }})
            </label>

            <input class="seg-buscar" [(ngModel)]="busqueda" placeholder="Buscar cliente…" />

            <!--
              El mismo orden que dan los encabezados, pero alcanzable en
              teléfono: ahí la tabla se apila y el `thead` no se muestra.
            -->
            <div class="seg-orden">
              <select [ngModel]="ordenCampo" (ngModelChange)="fijarOrden($event)">
                <option [ngValue]="null">Orden del tablero</option>
                <option [ngValue]="'callado'">Días callado</option>
                <option [ngValue]="'pct'">Porcentaje</option>
                <option [ngValue]="'ops'">Operaciones</option>
                <option [ngValue]="'ventana'">USDT de la ventana</option>
                <option [ngValue]="'semana'">USDT de la semana</option>
                <option [ngValue]="'base'">Base</option>
                <option [ngValue]="'contacto'">Últ. contacto</option>
                <option [ngValue]="'nombre'">Cliente</option>
              </select>
              <button
                *ngIf="ordenCampo"
                (click)="ordenAsc = !ordenAsc"
                [title]="ordenAsc ? 'De menor a mayor' : 'De mayor a menor'"
              >
                {{ ordenAsc ? '▲ menor a mayor' : '▼ mayor a menor' }}
              </button>
            </div>
          </div>

          <p class="seg-ayuda">
            El color compara <b>{{ ventanaDelTablero }}</b> contra el nivel normal de
            cada cliente, prorrateado a esos mismos días.
            <b>Verde</b> desde {{ (semana.umbralVerde * 100) | number: '1.0-0' }}%,
            <b>amarillo</b> desde {{ (semana.umbralAmarillo * 100) | number: '1.0-0' }}%.
            <span *ngIf="config?.semaforoModo === 'PEOR'">
              Se mira el peor de monto y frecuencia: quien mantiene el ticket y viene
              menos veces es el que se está llevando el flujo.
            </span>
            <span *ngIf="config?.ventanaDias">
              La columna <b>Semana</b> sigue siendo el total de los {{ semana.dias }} días
              que van de la semana: es lo que se reporta, no lo que pinta el color.
            </span>
          </p>

          <div class="seg-tabla-wrap">
            <table class="seg-tabla">
              <thead>
                <tr>
                  <th
                    class="l ord"
                    [class.activo]="ordenCampo === 'nombre'"
                    (click)="ordenarPor('nombre')"
                    title="Ordenar por nombre"
                  >
                    Cliente<i>{{ iconoOrden('nombre') }}</i>
                  </th>
                  <th class="l">Tier</th>
                  <th
                    class="ord"
                    [class.activo]="ordenCampo === 'semana'"
                    (click)="ordenarPor('semana')"
                    title="Ordenar por USDT de la semana"
                  >
                    Semana<i>{{ iconoOrden('semana') }}</i>
                  </th>
                  <th
                    class="ord"
                    [class.activo]="ordenCampo === 'ventana'"
                    (click)="ordenarPor('ventana')"
                    title="Ordenar por USDT de la ventana"
                  >
                    Ventana<i>{{ iconoOrden('ventana') }}</i>
                  </th>
                  <th
                    class="ord"
                    [class.activo]="ordenCampo === 'base'"
                    (click)="ordenarPor('base')"
                    title="Ordenar por base"
                  >
                    Base<i>{{ iconoOrden('base') }}</i>
                  </th>
                  <th
                    class="ord"
                    [class.activo]="ordenCampo === 'pct'"
                    (click)="ordenarPor('pct')"
                    title="Ordenar por porcentaje. Los que no tienen porcentaje quedan al final."
                  >
                    %<i>{{ iconoOrden('pct') }}</i>
                  </th>
                  <th
                    class="ord"
                    [class.activo]="ordenCampo === 'ops'"
                    (click)="ordenarPor('ops')"
                    title="Ordenar por operaciones"
                  >
                    Ops<i>{{ iconoOrden('ops') }}</i>
                  </th>
                  <th
                    class="ord"
                    [class.activo]="ordenCampo === 'callado'"
                    (click)="ordenarPor('callado')"
                    title="Ordenar por días sin operar. Los que nunca operaron quedan al final."
                  >
                    Callado<i>{{ iconoOrden('callado') }}</i>
                  </th>
                  <th class="l">Semáforo</th>
                  <th class="l">Dueño</th>
                  <th
                    class="l ord"
                    [class.activo]="ordenCampo === 'contacto'"
                    (click)="ordenarPor('contacto')"
                    title="Ordenar por fecha del último contacto. Los que no tienen contacto quedan al final."
                  >
                    Últ. contacto<i>{{ iconoOrden('contacto') }}</i>
                  </th>
                  <th class="l">Próxima acción</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let f of filasVisibles"
                  [class.fila-perdida]="f.semaforo === 'FUGADO'"
                >
                  <td class="l" data-etq="Cliente">
                    <span class="cli">{{ f.nombre }}</span>
                    <span class="tag mig" *ngIf="f.migracion" title="Apareció una cuenta nueva del mismo titular: migró de correo, no se fue">
                      migró
                    </span>
                    <span
                      class="tag prop"
                      *ngIf="f.cuentasPropuestas"
                      (click)="resolverPropuestas(f.clienteId)"
                      title="Resolver las uniones de cuenta de este titular"
                    >
                      {{ f.cuentasPropuestas }} por confirmar
                    </span>
                    <small *ngIf="f.cuentas > 1">{{ f.cuentas }} cuentas</small>
                  </td>

                  <td class="l" data-etq="Tier">
                    <span class="tier" [class]="'tier-' + f.tier.toLowerCase()">{{ f.tier }}</span>
                  </td>

                  <td class="n" data-etq="Semana">{{ f.usdt | number: '1.0-0' }}</td>

                  <td class="n" data-etq="Ventana" [title]="'USDT en ' + ventanaDe(f)">
                    {{ (f.ventanaDias ? f.ventanaUsdt : f.usdt) | number: '1.0-0' }}
                  </td>

                  <td class="n suave" data-etq="Base" [title]="'Nivel normal prorrateado a ' + ventanaDe(f)">
                    {{ (f.ventanaDias ? f.ventanaBaseUsdt : f.baseUsdt) | number: '1.0-0' }}
                  </td>

                  <td class="n" data-etq="%">{{ porcentaje(ratioQueManda(f)) }}</td>
                  <td class="n suave" data-etq="Ops">{{ opsDeLaVentana(f) }}</td>

                  <td
                    class="n"
                    data-etq="Callado"
                    [class.suave]="!f.silencio"
                    [class.seg-callado]="f.silencio"
                    [title]="f.silencioP90
                      ? 'Su p90 de huecos es ' + f.silencioP90 + ' días'
                      : 'Sin historia suficiente para tener cadencia propia'"
                  >
                    {{ textoSilencio(f) }}
                  </td>

                  <td class="l" data-etq="Semáforo">
                    <span class="sem" [class]="claseSemaforo(f.semaforo)">
                      <i></i>{{ etiquetaSemaforo(f) }}
                    </span>
                    <span class="tag racha" *ngIf="f.semanasEnRojo >= 2">
                      {{ f.semanasEnRojo }} sem
                    </span>
                    <span
                      class="tag monto-ok"
                      *ngIf="montoSanoMenosOps(f)"
                      title="Trajo el monto esperado o más, en menos operaciones. La alerta es de frecuencia, no de plata."
                    >
                      trajo el monto
                    </span>
                    <span class="tag rec" *ngIf="f.cambio === 'RECUPERADO'">recuperado</span>
                    <span class="tag cayo" *ngIf="f.cambio === 'CAYO'">cayó</span>
                  </td>

                  <td class="l suave" data-etq="Dueño">
                    {{ f.duenoEmail || (f.duenoSub ? 'asignado' : '—') }}
                  </td>
                  <td class="l suave" data-etq="Últ. contacto">
                    {{ f.ultimoContactoAt ? (f.ultimoContactoAt | date: 'dd/MM') : '—' }}
                  </td>
                  <td class="l suave accion" data-etq="Próxima acción">
                    <span *ngIf="f.proximaAccion">{{ f.proximaAccion }}</span>
                    <small *ngIf="f.proximaAccionAt">para el {{ f.proximaAccionAt | date: 'dd/MM' }}</small>
                    <span *ngIf="!f.proximaAccion" class="falta">sin plan</span>
                  </td>

                  <td>
                    <button mat-icon-button (click)="abrirGestion(f)" title="Gestionar">
                      <mat-icon>edit_note</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="seg-vacio" *ngIf="!filasVisibles.length">
              No hay clientes en esta vista.
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ============================================== 2. RECONQUISTA -->
      <mat-tab label="Reconquista">
        <div class="seg-tab">
          <p class="seg-ayuda">
            Clientes que operaban entre enero y agosto y llevan
            {{ config?.fugaDias || 90 }} días sin una sola operación. No son alertas de
            esta semana: son el objetivo del programa, y el monto es lo que valían
            cuando estaban enteros.
          </p>

          <div class="seg-fuga-kpis" *ngIf="fuga">
            <div class="kpi">
              <div class="kpi-l">En la lista</div>
              <div class="kpi-b num">{{ fuga.fugados }}</div>
              <div class="kpi-s">de {{ fuga.universo }} del universo</div>
            </div>
            <div class="kpi">
              <div class="kpi-l">Entraron hoy</div>
              <div class="kpi-b num rojo">{{ fuga.nuevos }}</div>
              <div class="kpi-s">volvieron {{ fuga.recuperados }}</div>
            </div>
            <div class="kpi">
              <div class="kpi-l">En juego</div>
              <div class="kpi-b num">{{ fuga.usdtReferencia | number: '1.0-0' }}</div>
              <div class="kpi-s">USDT al mes, a recuperar</div>
            </div>
            <div class="kpi">
              <div class="kpi-l">Whales perdidos</div>
              <div class="kpi-b num rojo">{{ fuga.fugadosWhale }}</div>
              <div class="kpi-s">{{ fuga.usdtReferenciaWhale | number: '1.0-0' }} USDT/mes</div>
            </div>
          </div>

          <div class="seg-grafico" *ngIf="serie.length > 1">
            <div class="seg-grafico-t">Cuántos hay en la lista</div>
            <div class="seg-grafico-box">
              <canvas
                baseChart
                type="line"
                [data]="graficoFugaStock"
                [options]="opcionesGrafico"
              ></canvas>
            </div>

            <div class="seg-grafico-t" style="margin-top: 1.1rem">
              ¿Crece o baja? · movimiento del día
            </div>
            <div class="seg-grafico-box seg-grafico-box-bajo">
              <canvas
                baseChart
                type="bar"
                [data]="graficoFugaFlujo"
                [options]="opcionesGraficoFlujo"
              ></canvas>
            </div>

            <p class="seg-grafico-nota" *ngIf="primerPuntoEsSiembra">
              El primer día de la serie es la puesta en marcha: se marcó de una vez a todos
              los que ya llevaban el plazo sin operar. No es un día de fugas.
            </p>
            <p class="seg-grafico-nota" *ngIf="diasSinFoto.length">
              Sin foto el {{ diasSinFoto.join(', ') }}: el proceso diario no corrió esos días
              y quedan como hueco en la curva, no como línea recta.
            </p>
          </div>

          <div class="seg-cargando" *ngIf="cargandoReconquista">Cargando…</div>

          <div class="seg-tabla-wrap" *ngIf="!cargandoReconquista">
            <table class="seg-tabla">
              <thead>
                <tr>
                  <th class="l">Cliente</th>
                  <th class="l">Tier</th>
                  <th>Valía al mes</th>
                  <th>Ops/mes</th>
                  <th>Sin operar</th>
                  <th class="l">Últ. operación</th>
                  <th class="l">Dueño</th>
                  <th class="l">Motivo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let f of reconquista">
                  <td class="l" data-etq="Cliente"><span class="cli">{{ f.nombre }}</span></td>
                  <td class="l" data-etq="Tier">
                    <span class="tier" [class]="'tier-' + f.tier.toLowerCase()">{{ f.tier }}</span>
                  </td>
                  <td class="n" data-etq="Valía al mes">{{ f.referenciaUsdtMensual | number: '1.0-0' }}</td>
                  <td class="n suave" data-etq="Ops/mes">{{ f.referenciaOpsMensual | number: '1.0-0' }}</td>
                  <td class="n" data-etq="Sin operar">{{ f.diasEnLista }} d</td>
                  <td class="l suave" data-etq="Últ. operación">
                    {{ f.ultimaOperacionAt ? (f.ultimaOperacionAt | date: 'dd/MM/yy') : '—' }}
                  </td>
                  <td class="l suave" data-etq="Dueño">{{ f.duenoEmail || '—' }}</td>
                  <td class="l suave" data-etq="Motivo">{{ f.motivoCodigo || 'sin averiguar' }}</td>
                  <td>
                    <button mat-icon-button (click)="abrirGestion(f)" title="Gestionar">
                      <mat-icon>edit_note</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="seg-vacio" *ngIf="!reconquista.length">
              Nadie en la lista de reconquista.
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ================================================ 3. DESEMPEÑO -->
      <mat-tab label="Desempeño">
        <div class="seg-tab">
          <p class="seg-ayuda">
            Se calculan al cerrar cada semana y quedan congelados: un número que se
            puede recalcular distinto el mes que viene no sirve para evaluar a nadie.
          </p>

          <div class="seg-filtros" *ngIf="semanas.length">
            <label class="seg-check">
              Semana cerrada
              <select [(ngModel)]="semanaKpiId" (ngModelChange)="cargarDesempeno($any($event))">
                <option *ngFor="let s of semanas" [value]="s.seguimientoSemanaId">
                  {{ s.fechaInicio | date: 'dd/MM' }} – {{ s.fechaFin | date: 'dd/MM' }}
                </option>
              </select>
            </label>
          </div>

          <div class="seg-cargando" *ngIf="cargandoDesempeno">Cargando…</div>
          <div class="seg-nota" *ngIf="notaDesempeno">{{ notaDesempeno }}</div>

          <div class="seg-kpis grandes" *ngIf="kpiGlobal && metas">
            <div class="kpi">
              <div class="kpi-l">Cobertura de alertas</div>
              <div
                class="kpi-b num"
                [class.verde]="cumpleMeta(kpiGlobal.coberturaPct, metas.coberturaPct)"
                [class.rojo]="cumpleMeta(kpiGlobal.coberturaPct, metas.coberturaPct) === false"
              >
                {{ kpiGlobal.coberturaPct !== null ? (kpiGlobal.coberturaPct | number: '1.0-0') + '%' : '–' }}
              </div>
              <div class="kpi-s">
                {{ kpiGlobal.alertasGestionadas }} de {{ kpiGlobal.alertas }} con dueño y plan
                · meta ≥ {{ metas.coberturaPct }}%
              </div>
            </div>

            <div class="kpi">
              <div class="kpi-l">Tiempo de reacción</div>
              <div
                class="kpi-b num"
                [class.verde]="cumpleMeta(kpiGlobal.reaccionDiasProm, metas.reaccionDias, true)"
                [class.rojo]="cumpleMeta(kpiGlobal.reaccionDiasProm, metas.reaccionDias, true) === false"
              >
                {{ kpiGlobal.reaccionDiasProm !== null ? (kpiGlobal.reaccionDiasProm | number: '1.0-1') + ' d' : '–' }}
              </div>
              <div class="kpi-s">
                {{ kpiGlobal.reaccionCasos }} whales en rojo contactados
                · meta ≤ {{ metas.reaccionDias }} d
              </div>
            </div>

            <div class="kpi">
              <div class="kpi-l">Recuperación a {{ metas.recuperacionVentanaDias }} días</div>
              <div
                class="kpi-b num"
                [class.verde]="cumpleMeta(kpiGlobal.recuperacionPct, metas.recuperacionPct)"
                [class.rojo]="cumpleMeta(kpiGlobal.recuperacionPct, metas.recuperacionPct) === false"
              >
                {{ kpiGlobal.recuperacionPct !== null ? (kpiGlobal.recuperacionPct | number: '1.0-0') + '%' : '–' }}
              </div>
              <div class="kpi-s">
                {{ kpiGlobal.recuperados }} de {{ kpiGlobal.recuperacionBase }} volvieron a verde
                · meta ≥ {{ metas.recuperacionPct }}%
              </div>
            </div>

            <div class="kpi">
              <div class="kpi-l">Whales rojos sin dueño</div>
              <div
                class="kpi-b num"
                [class.verde]="kpiGlobal.whalesRojoSinDueno === 0"
                [class.rojo]="kpiGlobal.whalesRojoSinDueno > 0"
              >
                {{ kpiGlobal.whalesRojoSinDueno }}
              </div>
              <div class="kpi-s">meta 0</div>
            </div>

            <div class="kpi">
              <div class="kpi-l">Volumen recuperado</div>
              <div class="kpi-b num verde">{{ kpiGlobal.usdtRecuperado | number: '1.0-0' }}</div>
              <div class="kpi-s">USDT en la semana · meta {{ metas.usdtMes | number: '1.0-0' }}/mes</div>
            </div>
          </div>

          <p class="seg-ayuda" *ngIf="kpiGlobal">
            Puntaje de la semana: <b>{{ puntajeDe('GLOBAL') !== null ? (puntajeDe('GLOBAL') | number: '1.0-1') : '–' }}</b>
            sobre 100, ponderado con los pesos de la <b>fase {{ fase }}</b>
            {{ fase === 1 ? '(pesa lo que el equipo controla: cobertura y reacción)' : '(pesa el resultado: recuperación)' }}.
            Un indicador sin casos no cuenta ni a favor ni en contra, y superar una meta
            no compensa fallar en otra.
          </p>

          <div class="seg-tabla-wrap" *ngIf="kpisPorDueno.length">
            <table class="seg-tabla">
              <thead>
                <tr>
                  <th class="l">Dueño</th>
                  <th>Puntaje</th>
                  <th>Alertas</th>
                  <th>Cobertura</th>
                  <th>Reacción</th>
                  <th>Recuperación</th>
                  <th>Whales sin dueño</th>
                  <th>USDT recuperado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let k of kpisPorDueno">
                  <td class="l" data-etq="Dueño">{{ nombreDueno(k) }}</td>
                  <td class="n" data-etq="Puntaje">
                    {{ puntajeDe(k.duenoSub) !== null ? (puntajeDe(k.duenoSub) | number: '1.0-1') : '–' }}
                  </td>
                  <td class="n" data-etq="Alertas">{{ k.alertasGestionadas }}/{{ k.alertas }}</td>
                  <td class="n" data-etq="Cobertura">{{ k.coberturaPct !== null ? (k.coberturaPct | number: '1.0-0') + '%' : '–' }}</td>
                  <td class="n" data-etq="Reacción">{{ k.reaccionDiasProm !== null ? (k.reaccionDiasProm | number: '1.0-1') + ' d' : '–' }}</td>
                  <td class="n" data-etq="Recuperación">{{ k.recuperacionPct !== null ? (k.recuperacionPct | number: '1.0-0') + '%' : '–' }}</td>
                  <td class="n" data-etq="Whales sin dueño">{{ k.whalesRojoSinDueno }}</td>
                  <td class="n" data-etq="USDT recuperado">{{ k.usdtRecuperado | number: '1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Los movimientos, con nombre: es lo que se lee en la reunión. -->
          <div class="seg-movs" *ngIf="recuperadosSemana.length || caidasSemana.length">
            <div class="seg-mov">
              <div class="seg-mov-t verde">Volvieron a verde ({{ recuperadosSemana.length }})</div>
              <div class="seg-mov-fila" *ngFor="let f of recuperadosSemana">
                <span>{{ f.nombre }}</span>
                <span class="n">{{ f.usdt | number: '1.0-0' }} USDT</span>
              </div>
              <div class="seg-mov-vacio" *ngIf="!recuperadosSemana.length">Ninguno</div>
            </div>
            <div class="seg-mov">
              <div class="seg-mov-t rojo">Nuevas caídas ({{ caidasSemana.length }})</div>
              <div class="seg-mov-fila" *ngFor="let f of caidasSemana">
                <span>{{ f.nombre }}</span>
                <span class="n">{{ f.usdt | number: '1.0-0' }} de {{ f.baseUsdt | number: '1.0-0' }}</span>
              </div>
              <div class="seg-mov-vacio" *ngIf="!caidasSemana.length">Ninguna</div>
            </div>
          </div>

          <!-- La evolución: una semana por fila, para ver si mejora. -->
          <div class="seg-tabla-wrap" *ngIf="semanas.length > 1">
            <table class="seg-tabla">
              <thead>
                <tr>
                  <th class="l">Semana</th>
                  <th>USDT</th>
                  <th>Esperado</th>
                  <th>Rojos</th>
                  <th>Amarillos</th>
                  <th>Whales rojos</th>
                  <th>Perdidos</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of semanas">
                  <td class="l" data-etq="Semana">
                    {{ s.fechaInicio | date: 'dd/MM' }} – {{ s.fechaFin | date: 'dd/MM' }}
                    <small *ngIf="s.dias !== 7">{{ s.dias }} días</small>
                  </td>
                  <td class="n" data-etq="USDT">{{ s.usdtTotal | number: '1.0-0' }}</td>
                  <td class="n suave" data-etq="Esperado">{{ s.usdtEsperado | number: '1.0-0' }}</td>
                  <td class="n" data-etq="Rojos">{{ s.clientesRojo }}</td>
                  <td class="n" data-etq="Amarillos">{{ s.clientesAmarillo }}</td>
                  <td class="n" data-etq="Whales rojos">{{ s.whalesRojo }}</td>
                  <td class="n suave" data-etq="Perdidos">{{ s.clientesFugado }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
